// @ts-nocheck
import { flow, getRoot, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { Anchor } from './models/Anchor';
import { RootStore } from './RootStore';
import { Page } from '../common/enums';

export const AnchorStore = types
  .compose(
    getBaseStore<Instance<typeof Anchor>, Instance<typeof Anchor>>(Anchor, 'anchorId', 'anchor'),
    types.model('AnchorStore', {}),
  )
  .actions((self) => {
    const root: Instance<typeof RootStore> = getRoot(self);

    const saveAnchor = flow(function*(anchor: Instance<typeof Anchor>) {
      const res = yield self.saveElement(anchor);
      // @ts-ignore
      if (anchor.anchorId !== res.anchorId) {
        // @ts-ignore
        root.ApplicationStore.navigate(`${Page.Anchors}/${res.anchorId}`);
      }
    });
    return { saveAnchor };
  });

export type AnchorStoreType = Instance<typeof AnchorStore>;
